import {
  ShippingAddressModel, BillingAddressModel, FileModel, CustomerModel,
  PartnerProductSubscriptionModel, PartnerProductModel, PartnerProductUnitModel,
} from '.';
import { unescape } from 'html-escaper';
import { translate } from '../helpers/frontend';

export class CustomerSubscriptionCartModel {
  constructor(data={}) {
    this._id = data?._id || null;
    
    this.customer = new CustomerModel(data.customer || {});
    
    this.shippingAddress = new ShippingAddressModel(data.shippingAddress || {});
    this.billingAddress = new BillingAddressModel(data.billingAddress || {});

    this.subscription = new PartnerProductSubscriptionModel(data.subscription || {});
    this.recurringSelection = this._recurringSelection(data.recurringSelection || {});

    this.relatedCredit = Number(data.relatedCredit || 1);
    this.relatedProducts = (data.relatedProducts || []).map(d => this.relatedProduct(d));
    this.freeCredit = Number(data.freeCredit || 1);
    this.freeProducts = (data.freeProducts || []).map(d => this.freeProduct(d));
    this.giveawayProducts = (data.giveawayProducts || []).map(d => this.giveawayProduct(d));

    this.selectionSteps = (data.selectionSteps || []).map(d => this.selectionStep(d));
    this.ecommerce = (data.ecommerce || []).map(d => new PartnerProductModel(d));

    this.discount = data.discount || data.discount===0? Number(data.discount): null;
    this.subtotal = data.subtotal || data.subtotal===0? Number(data.subtotal): null;
    
    this.vatName = data.vatName? unescape(data.vatName): '';
    this.vat = data.vat || data.vat===0? Number(data.vat): null;
    this.vatPercent = data.vatPercent || data.vatPercent===0? Number(data.vatPercent): null;

    this.total = data.total || data.total===0? Number(data.total): null;
    this.initialPriceInVAT = data.initialPriceInVAT || data.initialPriceInVAT===0? Number(data.initialPriceInVAT): null;

    this.cashDiscount = data.cashDiscount || data.cashDiscount===0? Number(data.cashDiscount): null;
    this.cashDiscountBirthMonth = data.cashDiscountBirthMonth || data.cashDiscountBirthMonth===0? Number(data.cashDiscountBirthMonth): null;
    this.cashDiscountRules = (data.cashDiscountRules || []).map(d => this.cashDiscountRule(d));

    this.grandTotal = data.grandTotal || data.grandTotal===0? Number(data.grandTotal): null;

    this.createdAt = data.createdAt || null;
    this.updatedAt = data.updatedAt || null;
  }

  isValid(){
    return this._id? true: false;
  }

  _recurringSelection(d={}){
    return {
      name: d.name || '',
      recurringType: d.recurringType || 2,
      recurringInterval: d.recurringInterval || 1,
      recurringCount: d.recurringCount || 3,
      discountPriceInVAT: Number(d.discountPriceInVAT ?? 0),
    };
  }
  relatedProduct(d={}){
    return {
      _id: d._id || null,
      product: new PartnerProductModel(d.product || {}),
      productId: d.product?._id,
      unit: new PartnerProductUnitModel(d.unit || {}),
      unitId: d.unit?._id,
      credit: d.credit ?? 1,
      addPriceInVAT: d.addPriceInVAT ?? 0,
      inCart: d.inCart ?? 0,
    };
  }
  selectionStep(d={}){
    return {
      _id: d._id || null,
      step: d.step || null,
      name: d.name? unescape(d.name): null,
      icon: new FileModel(d.icon || {}),
      credit: d.credit ?? 1,
      order: d.order || 1,
      products: d.products?.length? d.products.map(k => {
        return {
          product: new PartnerProductModel(k.product || {}),
          productId: k.product?._id,
          unit: new PartnerProductUnitModel(k.unit || {}),
          unitId: k.unit?._id,
          credit: k.credit ?? 1,
          inCart: k.inCart ?? 0,
        };
      }): [],
    };
  }
  freeProduct(d={}){
    return {
      _id: d._id || null,
      product: new PartnerProductModel(d.product || {}),
      productId: d.product?._id,
      unit: new PartnerProductUnitModel(d.unit || {}),
      unitId: d.unit?._id,
      credit: d.credit ?? 1,
      quantity: d.quantity ?? 1,
      inCart: d.inCart ?? d.quantity ?? 0,
    };
  }
  giveawayProduct(d={}){
    return {
      _id: d._id || null,
      product: new PartnerProductModel(d.product || {}),
      productId: d.product?._id,
      unit: new PartnerProductUnitModel(d.unit || {}),
      unitId: d.unit?._id,
      quantity: d.quantity ?? 1,
      inCart: d.inCart ?? d.quantity ?? 0,
    };
  }

  cashDiscountRule(d={}){
    return {
      name: d.name || null,
      startAt: d.startAt || null,
      endAt: d.endAt || null,
      cashRuleDiscount: Number(d.cashRuleDiscount ?? 0),
    };
  }
  
  hasShipBySupplier() {
    let shipBySupplier = false;
    [
      ...this.relatedProducts.map(d => d.product),
      ...this.selectionSteps.map(d => d.products).flat().map(d => d.product),
    ].forEach(d => {
      if(d.shipBySupplier) shipBySupplier = true;
    });
    return shipBySupplier;
  }
  shipBySupplierProducts() {
    return [
      ...this.relatedProducts.map(d => d.product),
      ...this.selectionSteps.map(d => d.products).flat().map(d => d.product),
    ].filter(d => d.product?.shipBySupplier);
  }

  displayFrequency(langObj={}){
    if(!this.isValid()) return '';
    let _text = '';
    if(this.subscription.type === 2){
      const _count = this.recurringSelection.recurringCount;
      if(_count===1) _text = translate('For _X_ Month', langObj, { '_X_': _count });
      else _text = translate('For _X_ Months', langObj, { '_X_': _count });
    }
    return _text;
  }
}